import React from 'react';
import { 
  FaLandmark, 
  FaAward, 
  FaBuilding, 
  FaWheelchair, 
  FaLaptopCode, 
  FaUserGraduate 
} from 'react-icons/fa';
import './AboutJourney.css';

const AboutJourney = () => {
  const journeySteps = [
    {
      year: "2008",
      label: "The Foundation",
      title: "A Vision for Rural Education",
      description: "The college was established with a mission of public welfare, aiming to provide quality teacher education to students in the rural outskirts of Jodhpur, bridging the urban-rural academic divide.",
      icon: <FaLandmark />,
    },
    {
      year: "2010", 
      label: "Affiliation & Recognition",
      title: "Official Accreditation",
      description: "Shortly after its inception, the college secured official recognition from the National Council for Teacher Education (NCTE) and permanent affiliation with Jai Narain Vyas University (JNVU).",
      icon: <FaAward />,
    },
    {
      year: "2012", 
      label: "Infrastructure Expansion",
      title: "Building the Campus",
      description: "Over the years, the institution expanded its 6-acre campus to include specialized facilities such as Psychology, Language, and Computer Laboratories to enhance practical learning.",
      icon: <FaBuilding />,
    },
    {
      year: "2015",
      label: "Focus on Inclusivity",
      title: "Empowering All Abilities",
      description: "A major milestone was the integration of specialized support for physically challenged students. We aligned our college with a broader social mission, ensuring education is accessible to everyone.",
      icon: <FaWheelchair />,
    },
    {
      year: "2020",
      label: "Technological Integration",
      title: "Modernizing Education",
      description: "The college transitioned into the modern era by adopting ICT-based learning and building a comprehensive digital library of over 3,390 volumes to support the evolving B.Ed. curriculum.",
      icon: <FaLaptopCode />,
    },
    {
      year: "Present",
      label: "Today's Success",
      title: "A Premier Institution",
      description: "Today, SKTTC stands as a premier destination for PTET-qualified students, having successfully placed thousands of teachers into the Rajasthan state education system.",
      icon: <FaUserGraduate />,
    }
  ];

  return (
    <section className="our-journey-of-about-section">
      <div className="our-journey-of-about-container">
        
        {/* Header Section */}
        <div className="our-journey-of-about-header">
          <span className="our-journey-of-about-badge">Est. 2008</span>
          <h2 className="our-journey-of-about-main-title">Our <span className="highlight-gold">Legacy</span> of Growth</h2>
          <p className="our-journey-of-about-subtext">
            From a humble rural initiative to a respected educational hub. Explore the milestones that define Sucheta Kriplani Teacher Training College.
          </p>
        </div>

        {/* Timeline Container */}
        <div className="our-journey-of-about-timeline">
          {/* The Central Line */}
          <div className="our-journey-of-about-center-line"></div>

          {journeySteps.map((step, index) => (
            <div 
              key={index} 
              className={`our-journey-of-about-row ${index % 2 === 0 ? 'left-aligned' : 'right-aligned'}`}
            >
              
              {/* DATE SECTION (Visible on opposite side of card) */}
              <div className="our-journey-of-about-date-wrapper">
                <h3 className="our-journey-of-about-year">{step.year}</h3>
                <span className="our-journey-of-about-label">{step.label}</span>
              </div>

              {/* CENTER NODE */}
              <div className="our-journey-of-about-node">
                <div className="our-journey-of-about-icon-box">
                  {step.icon}
                </div>
              </div>

              {/* CONTENT CARD */}
              <div className="our-journey-of-about-card">
                <div className="our-journey-of-about-card-content">
                  <div className="card-top-accent"></div>
                  <h4 className="our-journey-of-about-card-title">{step.title}</h4>
                  <p className="our-journey-of-about-card-desc">{step.description}</p>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutJourney;